'use strict';

const Action = require('./Action');

/**
 * @typedef {object} ExportedHideChildren
 *
 * @property {string} func Nombre de la función: hideChildren
 * @property {Array}  args Argumentos de entrada a la función:
 *                         - el ID del campo
 */

/**
 * Clase de gestión de una regla de tipo Ocultar hijos
 *
 * @extends {Structure.Action}
 *
 * @memberOf Structure
 */
class HideChildren extends Action {
    /**
     * @inheritDoc
     */
    constructor(rawAction) {
        super(rawAction);

        this.type = Action.Types.HIDE_CHILDREN;
        this.function = 'hideChildren';

        this.resetDescendants = !!rawAction.resetDescendants;
    }

    /**
     * Exportación de la acción en un objeto para la ejecución de las reglas
     *
     * @returns {ExportedHideChildren} Objeto de exportación de la acción
     */
    export() {
        const rawAction = super.export();
        rawAction.resetDescendants = this.resetDescendants;

        return rawAction;
    }
}

module.exports = HideChildren;
